var map = {
	"./dashboard.svg": 49557,
	"./example.svg": 51855,
	"./eye-open.svg": 60047,
	"./eye.svg": 59226,
	"./field.svg": 95753,
	"./form.svg": 96073,
	"./inventory.svg": 3297,
	"./link.svg": 14223,
	"./marketing.svg": 49545,
	"./nested.svg": 92362,
	"./password.svg": 22492,
	"./product.svg": 52048,
	"./project.svg": 76838,
	"./sales.svg": 92041,
	"./service-support.svg": 97438,
	"./service.svg": 63760,
	"./table.svg": 52697,
	"./tech.svg": 85879,
	"./training.svg": 30113,
	"./tree.svg": 40659,
	"./user.svg": 67082
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 11723;